import { useContext } from 'react';
import { createContext } from 'react';

import { AcceptedPaymentMethodsProps } from '../@types/AcceptedPaymentMethodsProps';

export const AcceptedPaymentMethodsContext = createContext<AcceptedPaymentMethodsProps>(
	{} as AcceptedPaymentMethodsProps,
);

AcceptedPaymentMethodsContext.displayName = 'AcceptedPaymentMethods';

const AcceptedPaymentMethodsProvider = (props: AcceptedPaymentMethodsProps) => (
	<AcceptedPaymentMethodsContext.Provider value={props}>{props.children}</AcceptedPaymentMethodsContext.Provider>
);

export const useAcceptedPaymentMethods = () => {
	const context = useContext(AcceptedPaymentMethodsContext);

	return context;
};

export default AcceptedPaymentMethodsProvider;
